<template>
  <div class="appointment-service-pairing-setting">
    <BobProPage
      ref="bobProPageRef"
      :columns="tableColumns"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      @refresh="onRefresh"
    />

    <EditAppointmentServicePairingModal
      v-if="modal.edit"
      :action="editAction"
      :selectRow="selectRow"
      @close="onCloseModal('edit')"
      @refresh="onRefresh"
    />

    <DeleteDialog
      v-if="modal.delete"
      title="提醒"
      content="刪除後將無法復原，確定要刪除這組推薦服務搭配？"
      width="610px"
      :loading="deleteLoading"
      @close="onCloseModal('delete')"
      @delete="onDelete"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { get } from 'lodash'
import BobProPage from '@/components/BobProPage.vue'
import DeleteDialog from '@/components/Dialog/DeleteDialog.vue'
import {
  GetAppointmentServicePairing,
  GetAppointmentServicePairingCount,
  DeleteAppointmentServicePairing,
} from '@/api/appointmentServicePairing'
import { useBobProPage } from '@/use/useBobProPage'
import { useShop } from '@/use/shop'
import notifyMessage from '@/config/notifyMessage'
import EditAppointmentServicePairingModal from './components/EditAppointmentServicePairingModal.vue'

// 預約模組 > 預約管理 > 推薦服務搭配設定（CNCY-10772）
// 店家指定服務的搭配關係，只用於推薦加購 AI Agent，不影響實際的預約單
export default defineComponent({
  name: 'AppointmentServicePairingSetting',
  components: {
    BobProPage,
    DeleteDialog,
    EditAppointmentServicePairingModal,
  },
  setup () {
    const { shopId } = useShop()
    const { modal, selectRow, editAction, bobProPageRef, onRefresh, onCloseModal } = useBobProPage()
    const deleteLoading = ref(false)

    const tableColumns = [
      {
        prop: 'mainService',
        label: '主要服務',
        component: () => import('./components/PairingServiceText.vue'),
        props: (row) => ({
          services: row.mainService ? [row.mainService] : [],
        }),
      },
      {
        prop: 'pairedServices',
        label: '搭配服務',
        component: () => import('./components/PairingServiceText.vue'),
        props: (row) => ({
          services: row.pairedServices,
        }),
      },
      {
        prop: 'order',
        label: '排序',
        component: 'div',
        render: (row) => row.order,
      },
      {
        prop: 'operate',
        label: '操作',
        fixed: 'right',
        component: () => import('@/components/OperateColumn.vue'),
        on: (row) => ({
          edit: () => {
            selectRow.value = row
            editAction.value = 'update'
            modal.edit = true
          },
          delete: () => {
            selectRow.value = row
            modal.delete = true
          },
        }),
      },
    ]

    const tableConfig = {
      pagination: {
        enabled: true,
        pageLimit: 10,
        pageSizes: [10, 20, 50],
      },
      apis: {
        get: GetAppointmentServicePairing,
        count: GetAppointmentServicePairingCount,
        getPayload: () => ({}),
      },
      filters: [],
    }

    const pageConfig = {
      title: '推薦服務搭配設定',
      actions: [
        {
          key: 'add',
          component: () => import('@/components/BaseElButton.vue'),
          render: () => '新增',
          props: {
            type: 'primary',
          },
          on: {
            click: () => {
              selectRow.value = null
              editAction.value = 'create'
              modal.edit = true
            },
          },
        },
      ],
    }

    const onDelete = async () => {
      if (deleteLoading.value) return
      deleteLoading.value = true
      const [, err] = await DeleteAppointmentServicePairing({
        shopId: shopId.value,
        id: get(selectRow.value, 'id'),
      })
      deleteLoading.value = false
      if (err) {
        window.$message.error(err)
        return
      }
      window.$message.success(notifyMessage.deleteSuccess)
      onCloseModal('delete')
      onRefresh()
    }

    return {
      modal,
      selectRow,
      editAction,
      bobProPageRef,
      tableColumns,
      tableConfig,
      pageConfig,
      deleteLoading,
      onRefresh,
      onCloseModal,
      onDelete,
    }
  },
})
</script>
